import models from './models';
import templates from './templates';

const QuestionUtils = {
  makeInputField(obj) {
    return models.makeOne(templates.inputField.merge(obj));
  },

  makeQuestionOption(obj) {
    return models.makeOne(templates.questionOption.merge(obj));
  },
};

export default QuestionUtils;
